module.exports = [
  ["#2395ff", "#f0f6ff"],
  ["#658a5a", "#f7ead0"],
  ["#f51d2b", "#e5fbff"],
  ["#022948", "#e6e59a"],
  ["#1a1a54", "#eeeeee"],
  ["#656f4d", "#fbecf1"],
  ["#218631", "#a2d6ff"],
]